import { cva } from 'class-variance-authority';

export const bannerVariants = cva('relative flex flex-col justify-start', {
  variants: {
    isFullHeight: {
      true: 'h-screen',
      false: '',
    },
  },
  defaultVariants: {
    isFullHeight: false,
  },
});
